import {
  Box,
  BoxProps,
  HStack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@chakra-ui/react';
import { useCallback, useState } from 'react';
import { useUser } from '../../../../../../../../../hooks/user';
import { UserBookingsList } from './components/UserBookingsList';
import { UserFeaturesTable } from './components/UserFeaturesTable';

export const UserDetailsTabs = (props: BoxProps): JSX.Element => {
  const { user } = useUser();

  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChanges = useCallback((index: number) => {
    setTabIndex(index);
  }, []);

  return (
    <Box {...props}>
      <Tabs
        index={tabIndex}
        onChange={handleTabChanges}
        variant="enclosed-colored"
        isLazy
      >
        <TabList>
          {user?.userAssignments[0]?.featureGroup?.key.includes('SELLER') && (
            <Tab>Reservas</Tab>
          )}

          <Tab>Permissões</Tab>
        </TabList>

        <TabPanels mt="4">
          {user?.userAssignments[0]?.featureGroup?.key.includes('SELLER') && (
            <TabPanel>
              <UserBookingsList />
            </TabPanel>
          )}

          <TabPanel>
            {!!user?.userAssignments[0]?.featureGroup && (
              <>
                <HStack>
                  <Text>Grupo de permissões:</Text>
                  <Text color="blue.500">
                    {user.userAssignments[0]?.featureGroup.name}
                  </Text>
                </HStack>

                <UserFeaturesTable
                  featureGroupId={user.userAssignments[0]?.featureGroupId}
                />
              </>
            )}
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
